import { useQuery, useMutation } from "react-query";
import {
  getAllIndexes,
  getIndexFormats,
  createIndexList,
} from "../api/indexes";

export const useGetAllIndexes = (options = {}) =>
  useQuery("getAllIndexes", getAllIndexes, options);

export const useGetIndexFormats = (options = {}) =>
  useQuery("getIndexFormats", getIndexFormats, options);

export const useCreateIndexList = (options = {}) => {
  return useMutation(createIndexList, options);
};

export default { useGetAllIndexes, useGetIndexFormats, useCreateIndexList };
